<template>
  <div
    class="preview"
    :class="{'preview_active': is_shown_preview}">
    <div
      @click="togglePreview"
      class="preview__text">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'preview__text-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 6a.5.5 0 01.853-.354l8.646 8.646 8.646-8.646a.5.5 0 01.707.707l-9 9a.5.5 0 01-.707 0l-9-9a.498.498 0 01-.146-.354z"/></svg>
      <span>
        <slot name="previewText"></slot>
      </span>
    </div>
    <img
      class="preview__img"
      :class="{'preview__img_small': type === 'small'}"
      alt="buzzoola format"
      :src="require(`@/assets/${img}`)">
  </div>
</template>

<script>
export default {
  name: 'formatPreview',
  props: {
    img: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      is_shown_preview: false,
    };
  },
  methods: {
    togglePreview() {
      this.is_shown_preview = !this.is_shown_preview;
    },
  },
};
</script>

<style scoped lang='stylus'>
@import '../../styles/main.styl'

.preview
  &__text
    display flex
    align-items center
    cursor pointer
    &-icon
      width 12px
      height 10px
      fill $darkYellow
      margin-right 5px
      transform rotate(-90deg)
      outline none
      border none
      ^[0]_active &
        transform rotate(0deg)
    & span
      fontSize(14, 20)
      color $darkYellow
      font-weight bold
  &__img
    display none
    width 100%
    max-width 800px
    height auto
    padding 15px
    box-sizing border-box
    &_small
      width 300px
    ^[0]_active &
      display block
    .vue-html2pdf-wrap &
      display block

</style>
